document.addEventListener('DOMContentLoaded',  () => {
    if (sessionStorage.getItem('high-contrast') === 'true') {
        document.body.classList.add('high-contrast');
    }

    const toggleButtons = document.querySelectorAll('.js-toggle-contrast a, .js-toggle-contrast button');

    toggleButtons.forEach(button => {
        button.addEventListener('click', function (event) {
            event.preventDefault(); // Prevent the default link behavior
            // Add your toggle logic here, for example:
            document.body.classList.toggle('high-contrast');

            sessionStorage.setItem('high-contrast', document.body.classList.contains('high-contrast').toString());
        });
    });

});